export const GET_OPT_IN_REQUEST = "GET_OPT_IN_REQUEST"
export const GET_OPT_IN_SUCCESS = "GET_OPT_IN_SUCCESS"
export const GET_OPT_IN_LIST_REQUEST = "GET_OPT_IN_LIST_REQUEST"
export const GET_OPT_IN_LIST_SUCCESS = "GET_OPT_IN_LIST_SUCCESS"
export const GET_OPT_IN_STATUS_REQUEST = "GET_OPT_IN_STATUS_REQUEST"
export const GET_OPT_IN_STATUS_SUCCESS = "GET_OPT_IN_STATUS_SUCCESS"